import React, { useEffect } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { useTailwindBreakpoint } from '@swyftx/aviary/hooks/useTailwindBreakpoint';
import { Page, PageContent } from '@swyftx/aviary/layout/Page';

import { cn } from '@shared/utils/lib/ui';

import { useIntercom } from 'react-use-intercom';

import { MarginAccountHealth, MarginAccountSummary, MarginPositionsHealth } from './components/Account';
import { SwyftxMarginDisclaimer } from './components/General';
import { SwyftxMarginStalePriceBanner } from './components/General/SwyftxMarginStalePriceBanner';

const SwyftxMarginAccount: React.FC = () => {
  const { update } = useIntercom();
  const isXs = useTailwindBreakpoint('xs');

  useEffect(() => {
    update({
      hideDefaultLauncher: true,
    });
  }, [update]);

  return (
    <FlexLayout
      direction='column'
      className='h-full w-full overflow-y-auto overflow-x-hidden'
      spacing={8}
      justifyContent='start'
    >
      <Page
        showCompactHeader={false}
        alignment='start'
        className={cn('mt-[-36px] pr-0 @container sm:mt-0 sm:pt-0')}
        customHeader={
          <FlexLayout
            className='mt-48 w-full pt-16 @container sm:mt-0 md:pt-32'
            direction='column'
            alignItems='start'
            justifyContent='start'
            spacing={12}
          >
            <div className='w-full pt-8 md:p-0'>
              <SwyftxMarginStalePriceBanner className='mb-24' />
            </div>

            <MarginAccountSummary className='w-full' hideTradeButton={!isXs} />
          </FlexLayout>
        }
      >
        <PageContent offset className='p-16 @container sm:p-16 md:p-32 lg:px-32 xl:px-64 xl:py-32'>
          <FlexLayout
            alignItems='start'
            className='h-full w-full flex-col gap-16 pb-78 @container sm:gap-24 md:gap-24 md:pb-0 xl:gap-32'
          >
            <FlexLayout alignItems='start' className='w-full flex-col gap-16 @md:flex-row lg:gap-32'>
              <FlexLayout className='w-full flex-col gap-16 md:flex-row lg:gap-24'>
                <MarginAccountHealth className='w-full md:w-4/12 ' stepIncrement={25} maxIncrement={250} />
                <MarginPositionsHealth className='h-full w-full md:w-8/12' />
              </FlexLayout>
            </FlexLayout>
            <SwyftxMarginDisclaimer />
          </FlexLayout>
        </PageContent>
      </Page>
    </FlexLayout>
  );
};

export { SwyftxMarginAccount };
